import { Box, Button, Stack } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { categoryTabs } from "utilities/common";
import { categoryTabsStilo } from "utilities/common";
import { STILO } from "utilities/constants";

function CategoryTabs() {
  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const categoriesFilter = searchParams.get("filter");
  const categoryView = searchParams.get("categoryView");

  const { adminsMode = "", isFullScreen = false } = useSelector((state) => state.common);

  const tabs = adminsMode === STILO ? categoryTabsStilo : categoryTabsStilo;

  return (
    <Box mb={2} className="cannabinoids-tabs">
      <Stack direction="row" gap={1} sx={{ background: "#ffffff" }}>
        {tabs.map((category) => (
          <Link
            key={category.value}
            to={`${pathname}?filter=${category.value}&categoryView=${categoryView}`}
            style={{ textDecoration: "none" }}
          >
            <Button
              size="medium"
              variant="outlined"
              sx={{
                color: categoriesFilter === category.value ? "primary.main" : "#2E2E3A",
                minWidth: "180px",
                borderColor:
                  categoriesFilter === category.value ? "primary.main" : "rgba(0, 0, 0, 0.23)",
                fontWeight: categoriesFilter === category.value ? "bold" : "normal",
              }}
            >
              {category.key}
            </Button>
          </Link>
        ))}
      </Stack>
    </Box>
  );
}

export default CategoryTabs;
